<template>
  <div style="width:100%;height:100%" :id="echartId"></div>
</template>

<script>
import uuidv1 from "uuid/v1";
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      echartId: uuidv1(),
      myChart: null,
    };
  },
  watch: {
    data(newData, oldData) {
      // console.log(newData);
      this.getEchartTwo(newData);
      this.getOption();
    },
  },
  mounted() {
    // console.log(this.data);
    let vm = this;
    this.getEchartTwo(this.data);
    window.addEventListener("resize", () => {
      if (vm.myChart) {
        vm.myChart.resize();
      }
    });
  },
  methods: {
    getEchartTwo(obj) {
      // console.log(obj);

      let this_ = this;
      this_.myChart = this.$echarts.init(
        document.getElementById(this.echartId)
      );

      var option = {
        title: {
          text: obj.title,
          left: "center",
          top: "0%",
        },
        grid: {
          x: 80,
          y: 50,
          x2: 50,
          y2: 60,
          borderWidth: 10,
          width: "90%",
        },

        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: obj.legend,
          top: "7%",
          icon: "line",
        },

        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "92%",
            left: "center",
          },
        ],
        // toolbox: {
        //   show: true,
        //   feature: {
        //     // dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar"] },
        //     // restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: obj.length,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
          },
        ],
        series: obj.series,
        // [
        //   {
        //     name: obj.legend,
        //     data: obj.dataone,
        //     type: "line",
        //     smooth: true
        //     markLine: {
        //       // symbol: "none", //去掉警戒线最后面的箭头
        //       label: {
        //         formatter: "{c}" + "%",
        //         position: "end" //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
        //       },
        //       data: [
        //         {
        //           silent: false, //鼠标悬停事件  true没有，false有
        //           lineStyle: {
        //             //警戒线的样式  ，虚实  颜色
        //             type: "solid",
        //             color: "#FA3934"
        //           },
        //           yAxis: this.warnValue // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
        //         }
        //       ]
        //     }
        //   }
        // ]
      };

      this_.myChart.setOption(option, true);
      if (this_.myChart) {
        window.addEventListener("resize", function() {
          this_.myChart.resize();
        });
      }
    },
    getOption() {
      let data = this.myChart.getOption();
      // );
      return data;
    },
  },
};
</script>

<style></style>
